import React from "react";

// import sections
import HeroSection from "./sections/HeroSection";
import PolicySection from "./sections/PolicySection";

const PrivacyPolicy = () => {
  return (
    <div>
      <HeroSection />
      <PolicySection />
    </div>
  );
};

export default PrivacyPolicy;
